import React from 'react';

const Document = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20" {...props}>
    <path
      fillRule="evenodd"
      d="M0 1.99C0 .892.895 0 1.994 0h12.012C15.107 0 16 .898 16 1.99v16.02c0 1.099-.895 1.99-1.994 1.99H1.994A1.997 1.997 0 0 1 0 18.01V1.99zM2 2v16h12V2H2zm9.003 12c.55 0 .997-.444.997-1 0-.552-.453-1-.997-1H4.997A.996.996 0 0 0 4 13c0 .552.453 1 .997 1h6.006zM4 10c0 .552.453 1 .997 1h6.006c.55 0 .997-.444.997-1 0-.552-.453-1-.997-1H4.997A.996.996 0 0 0 4 10zm7.003-2c.55 0 .997-.444.997-1 0-.552-.453-1-.997-1H4.997A.996.996 0 0 0 4 7c0 .552.453 1 .997 1h6.006z"
    />
  </svg>
);

export default Document;
